import { CampaignTypes } from '@/modules/base-campaign/models/base-campaign-resource.model'
import {
  BasicCampaignCollectionModel,
  BasicCampaignCollectionWithModel
} from '@/modules/base-campaign/models/base-campaign-collection.model'
import { Data } from '@/modules/shared/models/data'

export enum CouponStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export enum CouponDiscountUnit {
  FIXED = 'fixed',
  PERCENT = 'percent'
}

export interface BasicCouponResourceModel {
  id: number
  code: string
  amount: number
}

export interface CouponResourceModel {
  amount: number
  campaigns: BasicCampaignCollectionModel[]
  code: string
  created_at: string
  expired_at: string | null
  id: number
  item_quantity_limit: number | null
  prohibited_services: number[] | null
  required_services: number[] | null
  status: CouponStatus
  title: string
  type: CampaignTypes
  usage_count_limit: number | null
  used_count: number
  user_usage_limit: number | null
  users: number[] | null
  special_offer: boolean | null
  instructions: string | null
  discount_unit: CouponDiscountUnit
  maximum_discount: number
  minimum_number_purchase: number
}

export interface CouponResourceWithModel {
  types: { [key in CampaignTypes]: string }
  statuses: { [key in CouponStatus]: string }
  discount_units: { [key in CouponDiscountUnit]: string }
  campaigns_with: BasicCampaignCollectionWithModel
}

export type CouponResourceType = Data<CouponResourceModel> & CouponResourceWithModel
